import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';
import { Helmet } from 'react-helmet-async';
import './PrivacyPage.css'; // Wiederverwenden des Privacy-Page-Styles für Konsistenz

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const TermsPage = () => {
    return (
        <div className="privacy-page"> {/* Wiederverwenden der Klasse für Styling */}
            <Helmet>
                <title>AGB | Snus Verzeichnis Deutschland</title>
                <meta name="description" content="Allgemeine Geschäftsbedingungen (AGB) für die Nutzung von Snus Verzeichnis Deutschland." />
                <meta name="robots" content="noindex, follow" />
                <link rel="canonical" href="https://www.snus-finder.de/agb" />
            </Helmet>

            <div className="privacy-header">
                <div className="container">
                    <Title level={1}>Allgemeine Geschäftsbedingungen (AGB)</Title>
                    <p className="last-updated">Stand: [Datum einfügen]</p>
                </div>
            </div>

            <div className="container">
                <Row justify="center">
                    <Col xs={24} md={20} lg={16}>
                        <Card style={{ marginBottom: '24px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>

                            <section className="privacy-section">
                                <Title level={2}>1. Geltungsbereich</Title>
                                <Paragraph>
                                    Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") gelten für alle Verträge und Leistungen zwischen Heinz Consulting (nachfolgend "Anbieter") und den Nutzern (nachfolgend "Nutzer") der Online-Plattform "Snus Verzeichnis Deutschland" (nachfolgend "Plattform").
                                </Paragraph>
                                <Paragraph>
                                    Nutzer können sowohl Verbraucher als auch Unternehmer sein. Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können. Unternehmer ist eine natürliche oder juristische Person oder eine rechtsfähige Personengesellschaft, die bei Abschluss eines Rechtsgeschäfts in Ausübung ihrer gewerblichen oder selbständigen beruflichen Tätigkeit handelt.
                                </Paragraph>
                            </section>

                            <section className="privacy-section">
                                <Title level={2}>2. Leistungen des Anbieters</Title>
                                <Paragraph>
                                    Die Plattform stellt ein Verzeichnis von Geschäften dar, die Snus und ähnliche Produkte anbieten. Nutzer können nach Shops suchen und Informationen wie Adresse, Öffnungszeiten und angebotene Marken einsehen.
                                </Paragraph>
                                <Paragraph>
                                    Shop-Betreiber haben die Möglichkeit, sich und ihren Shop auf der Plattform zu registrieren und zu präsentieren. Je nach gewähltem Leistungspaket können unterschiedliche Funktionen zur Verfügung stehen (z.B. erweiterte Profile, Hervorhebung).
                                </Paragraph>
                                <Paragraph>
                                    Der Anbieter bemüht sich um die Richtigkeit und Aktualität der dargestellten Informationen, übernimmt jedoch keine Gewähr für die Vollständigkeit und Korrektheit der von den Shop-Betreibern eingestellten Daten.
                                </Paragraph>
                            </section>

                            <section className="privacy-section">
                                <Title level={2}>3. Registrierung und Nutzerkonto (falls zutreffend)</Title>
                                <Paragraph>
                                    [Hier Regelungen zur Registrierung von Nutzern und/oder Shop-Betreibern einfügen, falls ein Login-Bereich existiert. Z.B. Pflichtangaben, Passwortsicherheit, Pflichten des Nutzers bezüglich der Aktualität seiner Daten.]
                                </Paragraph>
                                <Paragraph>
                                    Shop-Betreiber sind für die Richtigkeit und Vollständigkeit der Angaben zu ihrem Geschäft selbst verantwortlich.
                                </Paragraph>
                            </section>

                            <section className="privacy-section">
                                <Title level={2}>4. Kosten und Zahlungsbedingungen (falls zutreffend)</Title>
                                <Paragraph>
                                    [Hier Regelungen zu eventuellen Kosten für Shop-Betreiber einfügen. Z.B. Preise für verschiedene Pakete, Zahlungsmodalitäten, Laufzeiten, Kündigungsfristen.]
                                </Paragraph>
                                <Paragraph>
                                    Die Basis-Nutzung der Suchfunktion für Endverbraucher ist kostenlos.
                                </Paragraph>
                            </section>

                            <section className="privacy-section">
                                <Title level={2}>5. Pflichten der Nutzer / Shop-Betreiber</Title>
                                <Paragraph>
                                    Nutzer verpflichten sich, die Plattform nicht missbräuchlich zu verwenden.
                                </Paragraph>
                                <Paragraph>
                                    Shop-Betreiber verpflichten sich, nur wahrheitsgemäße Angaben zu machen und keine Rechte Dritter (z.B. Markenrechte, Urheberrechte, Persönlichkeitsrechte) zu verletzen. Sie stellen sicher, dass die beworbenen Produkte legal verkauft werden dürfen.
                                </Paragraph>
                                <Paragraph>
                                    [Weitere spezifische Pflichten, z.B. bezüglich Bewertungen, Kommunikation etc.]
                                </Paragraph>
                            </section>

                            <section className="privacy-section">
                                <Title level={2}>6. Haftung</Title>
                                <Paragraph>
                                    Der Anbieter haftet für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) sowie bei Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.
                                </Paragraph>
                                <Paragraph>
                                    Die Haftung für leicht fahrlässig verursachte Verletzungen wesentlicher Vertragspflichten ist auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
                                </Paragraph>
                                <Paragraph>
                                    Der Anbieter haftet nicht für die Richtigkeit, Vollständigkeit und Aktualität der von Shop-Betreibern bereitgestellten Informationen.
                                </Paragraph>
                                <Paragraph>
                                    [Evtl. spezifische Haftungsausschlüsse oder -begrenzungen, die rechtlich zulässig sind.]
                                </Paragraph>
                            </section>

                            <section className="privacy-section">
                                <Title level={2}>7. Datenschutz</Title>
                                <Paragraph>
                                    Hinsichtlich des Datenschutzes wird auf die separate Datenschutzerklärung verwiesen, die unter [Link zur Datenschutzerklärung] abrufbar ist.
                                </Paragraph>
                            </section>

                            <section className="privacy-section">
                                <Title level={2}>8. Änderungen der AGB</Title>
                                <Paragraph>
                                    Der Anbieter behält sich vor, diese AGB jederzeit zu ändern. Nutzer werden über Änderungen rechtzeitig informiert. Widerspricht der Nutzer den geänderten AGB nicht innerhalb einer angemessenen Frist nach Zugang der Änderungsmitteilung, gelten die geänderten AGB als angenommen.
                                </Paragraph>
                            </section>

                            <section className="privacy-section">
                                <Title level={2}>9. Schlussbestimmungen</Title>
                                <Paragraph>
                                    Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
                                </Paragraph>
                                <Paragraph>
                                    Sofern der Nutzer Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist, ist Gerichtsstand für alle Streitigkeiten aus Vertragsverhältnissen zwischen dem Nutzer und dem Anbieter der Sitz des Anbieters (Tübingen).
                                </Paragraph>
                                <Paragraph>
                                    Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
                                </Paragraph>
                            </section>

                            <Paragraph style={{ marginTop: '30px', fontStyle: 'italic' }}>
                                Hinweis: Dies ist ein Mustertext. Bitte passen Sie die AGB an Ihre spezifischen Geschäftsprozesse an und lassen Sie sie gegebenenfalls rechtlich prüfen.
                            </Paragraph>

                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default TermsPage; 